import React, {useState} from "react";
import axios from "axios";
import {ROOT_URL} from "../../../config/url";
import {getErrorMessageByKey, Modal, useNotification,} from "@vokymlak/kabinet-ui";
import moment from "moment";
import ReactJsonPrint from "react-json-print";

function ModalGetTransactions(props) {
  const [data, setData] = useState(null);
  const {notification} = useNotification();

  const changeAdd = (event) => {
    event.preventDefault();

    axios
      .get("/api/alfabank/transactions", {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  return (
    <Modal handleClose={() => props.handleClose()} contentStyle={{
      width: 540
    }}>
      <form className="Form" onSubmit={(event) => changeAdd(event)}>
        <div className="Form__title">
          Выписка по счёту
          <div className="Text__signature">на {moment().subtract(24, 'hours').format("DD.MM.YYYY")}</div>
        </div>

        {!!data && <ReactJsonPrint expanded dataString={JSON.stringify(data)}/>}

        <div className="Form__actions Form__actions_center">
          <button className="Action__button Action__button_all Action__button_blue">
            Продолжить
          </button>
        </div>

        <div className="Form__actions Form__actions_center">
          <div className="Action__link" onClick={() => props.handleClose()}>
            Закрыть
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default ModalGetTransactions;
